var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ViewChildren } from '@angular/core';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ContentBaseService } from '../../../../component/base/contentbase.service';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
var KtsPartnerAreaComponent = /** @class */ (function (_super) {
    __extends(KtsPartnerAreaComponent, _super);
    function KtsPartnerAreaComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.partnerCompanyAreaIds = {};
        _this.checkedAreaNames = [];
        _this.areaOption = [];
        _this.readonly = false;
        return _this;
    }
    KtsPartnerAreaComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.getType();
    };
    KtsPartnerAreaComponent.prototype.getType = function () {
        var _this = this;
        this.service.getType('PARTNER_COMPANY_AREA').subscribe(function (rec) { return _this.areaOption = rec; });
    };
    KtsPartnerAreaComponent.prototype.onSubscribe = function (data) {
        for (var _i = 0, _a = data.area_ids; _i < _a.length; _i++) {
            var id = _a[_i];
            this.partnerCompanyAreaIds[id] = true;
        }
        this.areaElement.map(function (el, index) {
            if (data.area_ids.includes(index + 1)) {
                el.nativeElement.checked = true;
            }
        });
        this.SetCompRec();
    };
    KtsPartnerAreaComponent.prototype.onModeSubscribe = function (mode) {
        if (mode === 'confirm') {
            this.readonly = true;
        }
        else {
            this.readonly = false;
        }
    };
    KtsPartnerAreaComponent.prototype.onEvent = function (e1, e2, area) {
        if (e2 === 'checkArea') {
            if (typeof this.partnerCompanyAreaIds[area] === 'undefined') {
                this.partnerCompanyAreaIds[area] = true;
            }
            else {
                this.partnerCompanyAreaIds[area] = !this.partnerCompanyAreaIds[area];
            }
        }
        this.SetCompRec();
    };
    KtsPartnerAreaComponent.prototype.onEventSubscribe = function (e) {
        var _this = this;
        if (e === this.componentName + '#checkAll') {
            this.areaElement.map(function (el, index) {
                el.nativeElement.checked = true;
                _this.partnerCompanyAreaIds[index + 1] = true;
            });
        }
        else if (e === this.componentName + '#uncheckAll') {
            this.areaElement.map(function (el, index) {
                el.nativeElement.checked = false;
                _this.partnerCompanyAreaIds[index + 1] = false;
            });
        }
        this.SetCompRec();
    };
    KtsPartnerAreaComponent.prototype.SetCompRec = function () {
        this.area_ids = [];
        this.checkedAreaNames = [];
        for (var key in this.partnerCompanyAreaIds) {
            if (this.partnerCompanyAreaIds[key]) {
                this.area_ids.push(Number(key));
                this.checkedAreaNames.push(this.areaOption[Number(key) - 1].display);
            }
        }
        if (this.checkedAreaNames.length === 0) {
            this.checkedAreaNames.push(this.msgSnapshot['au.COMPONENT.KtsPartnerAreaComponent.label.unchecked']);
        }
        this.action.setCompRec(this.componentName, { area_ids: this.area_ids });
    };
    KtsPartnerAreaComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-partner-area',
                    template: "<div id=\"{{ componentName }}\">\n  <div *ngIf=\"!readonly\" class=\"row -mb-1\">\n    <btn\n    [componentName]=\"componentName + '#Button_checkAll'\"\n    [component]=\"{\n      params: {\n        buttons: [{\n          type: 'button',\n          event: componentName + '#checkAll',\n          caption: (msg | async)['au.COMPONENT.KtsPartnerAreaComponent.label.check_all']\n        }]\n      }\n    }\" class=\"-mr-1\"></btn>\n    <btn\n    [componentName]=\"componentName + '#Button_uncheckAll'\"\n    [component]=\"{\n      params: {\n        buttons: [{\n          type: 'button',\n          event: componentName + '#uncheckAll',\n          caption: (msg | async)['au.COMPONENT.KtsPartnerAreaComponent.label.uncheck_all']\n        }]\n      }\n    }\"></btn>\n  </div>\n  <div class=\"-mb-1\">\n    <div [hidden]=\"readonly\" class=\"col-sm-12\">\n      <div *ngFor=\"let area of areaOption\" style=\"display: inline\">\n        <input type=\"checkbox\" id=\"{{ componentName + '_area' + area.code }}\" class=\"formInputCheckbox\" value=\"{{ area.code }}\" (change)=\"onEvent($event, 'checkArea', area.code)\" #checkArea>\n        <label for=\"{{ componentName + '_area' + area.code }}\" class=\"formInputCheckboxLabel\">{{ area.display }}</label>\n      </div>\n    </div>\n    <div *ngIf=\"readonly\" class=\"col-sm-12\">\n      <div *ngFor=\"let name of checkedAreaNames\" class=\"-mr-1 -my-1\" style=\"display: inline-block\">\n        <span class=\"formReadOnly\">{{ name }}</span>\n      </div>\n    </div>\n  </div>\n</div>"
                }] }
    ];
    /** @nocollapse */
    KtsPartnerAreaComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService }
    ]; };
    KtsPartnerAreaComponent.propDecorators = {
        areaElement: [{ type: ViewChildren, args: ['checkArea',] }]
    };
    return KtsPartnerAreaComponent;
}(ContentBaseComponent));
export { KtsPartnerAreaComponent };
//# sourceMappingURL=partner-area.component.js.map